import { BrowserModule } from "@angular/platform-browser";
import { NgModule } from "@angular/core";
import { HttpClientModule, HttpErrorResponse } from "@angular/common/http";

// Import Modules
import { CoreModule } from "./core/core.module";
import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { SharedModule } from "@root/shared/shared.module";
import { ControlAutocompleteComponent } from "./shared/common-controls/control-autocomplete/control-autocomplete.component";
import { PdfViewerModule } from "ng2-pdf-viewer";
import { AuthService } from "@services/auth/auth.service";
//import { AuthRedirectGuard } from './auth/guards/auth-redirect.guard';
import { AuthGuard } from "./auth/guards/auth.guard";
import { SafePipe } from "./safe.pipe";
/* import { FroalaEditorModule, FroalaViewModule } from 'angular-froala-wysiwyg'; */
import { DatePipe } from "@angular/common";
import { MicrosoftApplicationInsightsService } from "@services/microsoft-application-insights.service";
import { RouterModule } from "@angular/router";
import { APP_INITIALIZER } from "@angular/core";
import { CustomerFacadeService } from "@services/configuration/customer-facade.service";
import { CustomerModel } from "@models/configuration/customer.model";
import {
  NgxPermissionsModule,
  NgxPermissionsService,
  NgxRolesService,
} from "ngx-permissions";

@NgModule({
  declarations: [AppComponent, SafePipe],
  imports: [
    BrowserModule,
    AppRoutingModule,
    CoreModule.forRoot(),
    HttpClientModule,
    BrowserAnimationsModule,
    PdfViewerModule,
    SharedModule,
    RouterModule.forRoot([
      { path: "", component: MicrosoftApplicationInsightsService },
    ]),
    NgxPermissionsModule.forRoot(),
  ],
  providers: [
    ControlAutocompleteComponent,
    AuthGuard,
    AuthService,
    DatePipe,
    {
      provide: APP_INITIALIZER,
      useFactory: (
        acl: CustomerFacadeService,
        ps: NgxPermissionsService,
        rs: NgxRolesService
      ) => {
        return () => {
          return new Promise<any[]>((resolve, reject) =>
            acl.getAllowsByMenu().subscribe(
              (value) => resolve(value),
              (error) => reject(error)
            )
          )
            .then((data) => {
              data.forEach((response: CustomerModel[]) => ps.addPermission([]));
              data.forEach((response: CustomerModel) => {
                //console.log(response);
                rs.addRole(response.nameArea, []);
              });
              return data;
            })
            .catch((err: HttpErrorResponse) => {
              console.log(err.error);
            });
        };
      },
      deps: [CustomerFacadeService, NgxPermissionsService, NgxRolesService],
      multi: true,
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
